import { checkTodayInRange } from '@/utils/checkTodayInRange';

const INVITE_EVENT_CODE_CHANGE_START_DATE = '2025-12-16T00:00:00' as const;
const INVITE_EVENT_CODE_CHANGE_END_DATE = '2099-12-31T23:59:59' as const;

/**
 * 친구초대 이벤트가 변경되는 시점(2025-12-16 00:00:00, KST) 이후인지 확인
 *
 * @returns 변경 시점 이후(포함)이면 true, 아니면 false
 */
export const isSecondDecemberEvent = (): boolean => {
  return checkTodayInRange(
    INVITE_EVENT_CODE_CHANGE_START_DATE,
    INVITE_EVENT_CODE_CHANGE_END_DATE,
  );
};
